import { Constants } from "@eagerdog/constants";
import { IEventRegisterRow } from "../../../services/helper.service.js";
import { IShow } from "@eagerdog/interfaces";

export namespace UKCPrecisionCoursing {
  export const getForm = (show?: IShow): IEventRegisterRow[] => {
    // Helper function to check if an element/level is available in the show
    const isElementAvailable = (elementOrLevel: string): boolean => {
      if (!show?.show_elements) return true; // If no show provided, show all options
      
      return show.show_elements.some(se => 
        se.show_element === elementOrLevel || se.level === elementOrLevel
      );
    };

    // All PC levels (competitive + non-competitive) live under show_element "Precision Coursing"
    // on every show. Fun Run and Puppy Dash must share the same label so that show_element is
    // stored correctly — FormBuilder uses input.label as the stored show_element value.
    const precisionCoursingOptions = [
      { value: Constants.dog_class_element_level.novice, id: Constants.dog_class_element_level.novice },
      { value: Constants.dog_class_element_level.advanced, id: Constants.dog_class_element_level.advanced },
      { value: Constants.dog_class_element_level.superior, id: Constants.dog_class_element_level.superior },
      { value: Constants.dog_class_element_level.master, id: Constants.dog_class_element_level.master },
      { value: Constants.dog_class_element_level.elite, id: Constants.dog_class_element_level.elite },
      { value: Constants.dog_class_element_level.dash, id: Constants.dog_class_element_level.dash },
      { value: Constants.dog_class_element_level.steeplechase, id: Constants.dog_class_element_level.steeplechase },
      { value: Constants.dog_class_element_level.fun_run, id: Constants.dog_class_element_level.fun_run },
      { value: Constants.dog_class_element_level.puppy_dash, id: Constants.dog_class_element_level.puppy_dash },
    ].filter(option => isElementAvailable(option.value));

    const formRows: IEventRegisterRow[] = [];

    if (precisionCoursingOptions.length > 0) {
      formRows.push({
        allowDuplicates: false,
        inputs: [{
          type: "checkbox",
          multiSelect: true,
          flex: 2,
          label: Constants.dog_class_element.precision_coursing,
          options: precisionCoursingOptions
        }]
      });
    }

    return formRows;
  };

  // Keep the original form for backward compatibility
  export const form: IEventRegisterRow[] = getForm();
}